import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MdStar } from "react-icons/md";
import "../../../index.css";
import Img1 from "../../../helper/images/hotel.png";
import { IoStarOutline } from "react-icons/io5";
import { useTranslation } from "../../../hooks/useTranslation";
const AboutTestimoinals = ({ percentage }) => {
  const { t } = useTranslation();
  var settings2 = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    cssEase: "linear",
  };
  return (
    <>
      <div className="container testimonials">
        <div className="lg:py-[100px] lg:pb-[150px] md:py-[70px] py-[30px]">
          <div className="align-middle w-full max-w-[1280px] mx-auto first-letter:gap-4 md:gap-8 bg-color relative bg-white md:py-[81px] md:pr-[81px] md:pl-[16px] py-[30px] px-[20px] rounded-[8px] border border-[#E5E5E5]">
            <div className="inline-block align-top w-full xl:max-w-[433px]  md:max-w-[50%] ">
              <h2 className="lg:text-[70px] md:text-[50px] text-[30px] font-bold md:leading-[63px] leading-10 text-center">
                4.9
              </h2>
              <p className="text-sm text-[#555555] font-semibold mt-1  text-center">
                {t("about").testimonials.basedOn}
              </p>
              <div className="grid grid-cols-[auto_1fr] gap-4 md:gap-5 mt-5 justify-start py-[6px] px-[10px]">
                <div className="flex items-center w-auto max-w-[60px]">
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                </div>
                <div className="flex items-center w-full gap-[33px]">
                  <div className="w-full bg-[#EEEEEE] h-[5px] rounded-[2px] overflow-hidden">
                    <div
                      className="bg-[#4CAF50] h-[5px] rounded-[2px]"
                      style={{ width: "95%" }}
                    ></div>
                  </div>
                  <span className="text-[#555555] text-[11px] font-bold">
                    95%
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-[auto_1fr] gap-4 md:gap-5  justify-start py-[6px] px-[10px]">
                <div className="flex items-center w-auto max-w-[60px]">
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                </div>
                <div className="flex items-center w-full gap-[33px]">
                  <div className="w-full bg-[#EEEEEE] h-[5px] rounded-[2px] overflow-hidden">
                    <div
                      className="bg-[#4CAF50] h-[5px] rounded-[2px]"
                      style={{ width: "5%" }}
                    ></div>
                  </div>
                  <span className="text-[#555555] text-[11px] font-bold">
                    5%
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-[auto_1fr] gap-4 md:gap-5  justify-start py-[6px] px-[10px]">
                <div className="flex items-center w-auto max-w-[60px]">
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                </div>
                <div className="flex items-center w-full gap-[33px]">
                  <div className="w-full bg-[#EEEEEE] h-[5px] rounded-[2px] overflow-hidden">
                    <div
                      className="bg-[#4CAF50] h-[5px] rounded-[2px]"
                      style={{ width: "0%" }}
                    ></div>
                  </div>
                  <span className="text-[#555555] text-[11px] font-bold">
                    0%
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-[auto_1fr] gap-4 md:gap-5  justify-start py-[6px] px-[10px]">
                <div className="flex items-center w-auto max-w-[60px]">
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                </div>
                <div className="flex items-center w-full gap-[33px]">
                  <div className="w-full bg-[#EEEEEE] h-[5px] rounded-[2px] overflow-hidden">
                    <div
                      className="bg-[#4CAF50] h-[5px] rounded-[2px]"
                      style={{ width: "0%" }}
                    ></div>
                  </div>
                  <span className="text-[#555555] text-[11px] font-bold">
                    0%
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-[auto_1fr] gap-4 md:gap-5  justify-start py-[6px] px-[10px]">
                <div className="flex items-center w-auto max-w-[60px]">
                  <MdStar size={11} className="text-[#F0AD4E]" />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                  <IoStarOutline size={11} className="text-[#F0AD4E] " />
                </div>
                <div className="flex items-center w-full gap-[33px]">
                  <div className="w-full bg-[#EEEEEE] h-[5px] rounded-[2px] overflow-hidden">
                    <div
                      className="bg-[#4CAF50] h-[5px] rounded-[2px]"
                      style={{ width: "0%" }}
                    ></div>
                  </div>
                  <span className="text-[#555555] text-[11px] font-bold">
                    0%
                  </span>
                </div>
              </div>
            </div>
            <div className="inline-block w-full xl:max-w-[700px]  md:max-w-[50%] lg:pl-[68px] md:pl-[20px] align-middle filter-slider mt-[20px]">
              <Slider {...settings2}>
                {/* =========1st slider item ========= */}
                <div className="itms-shadow rounded-[10px] bg-white">
                  <div className="flex items-center">
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                  </div>
                  <p className="text-[15px] text-[#555555] leading-[30px] pt-[14px] pb-[10px]">
                    {t("about").testimonials.review1.text}
                  </p>
                  <span className="text-[#555555] text-sm font-semibold">
                    {t("about").testimonials.review1.author}
                  </span>
                </div>
                {/* =========2nd slider item ========= */}
                <div className="itms-shadow rounded-[10px] bg-white">
                  <div className="flex items-center">
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                  </div>
                  <p className="text-[15px] text-[#555555] leading-[30px] pt-[14px] pb-[10px]">
                    {t("about").testimonials.review1.text}
                  </p>
                  <span className="text-[#555555] text-sm font-semibold">
                    {t("about").testimonials.review1.author}
                  </span>
                </div>
                {/* =========3rd slider item ========= */}
                <div className="itms-shadow rounded-[10px] bg-white">
                  <div className="flex items-center">
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                  </div>
                  <p className="text-[15px] text-[#555555] leading-[30px] pt-[14px] pb-[10px]">
                    {t("about").testimonials.review1.text}
                  </p>
                  <span className="text-[#555555] text-sm font-semibold">
                    {t("about").testimonials.review1.author}
                  </span>
                </div>
                {/* =========4th slider item ========= */}
                <div className="itms-shadow rounded-[10px] bg-white">
                  <div className="flex items-center">
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                    <MdStar size={21} className="text-[#FF9D00]" />
                  </div>
                  <p className="text-[15px] text-[#555555] leading-[30px] pt-[14px] pb-[10px]">
                    {t("about").testimonials.review1.text}
                  </p>
                  <span className="text-[#555555] text-sm font-semibold">
                    {t("about").testimonials.review1.author}
                  </span>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutTestimoinals;
